export enum QuestionType {
  Text = 'Text',
  Bool = 'Bool',
  File = 'File',
  Conditional = 'Conditional',
}

export interface InsuranceQuestionDto {
  id?: number;
  title?: string | null;
  description?: string | null;
  type?: QuestionType | null;
  // Optional dependency: show only when another question has a specific value
  dependsOnQuestionId?: number | null;
  dependsOnValue?: string | null;
  cancelOnValue?: string | null;
  // If true, the question must be answered
  required?: boolean;
  // If true, hide this question on checkout page
  hideOnCheckout?: boolean;
  // Position inside its group, set in the backoffice (0-based)
  sortOrder?: number;
}
